import { createAuthContext } from '@react-keycloak/core';
export var reactKeycloakWebContext = createAuthContext();
export var ReactKeycloakWebContextConsumer = reactKeycloakWebContext.Consumer;
//# sourceMappingURL=context.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-keycloak/web/lib/context.js
// module id = 221
// module chunks = 0